import PropTypes from 'prop-types'

const PlacementName = ({ type, categories }) => {
  const searchPlacements = []
  const contentPlacements = []
  if (categories.includes('PREMIUM_LINK_SEARCH_KAKAO')) {
    searchPlacements.push('카카오, 다음')
  }
  if (categories.includes('PREMIUM_LINK_CONTENT_KAKAO')) {
    contentPlacements.push('카카오, 다음')
  }
  if (categories.includes('PREMIUM_LINK_CONTENT_PARTNER')) {
    contentPlacements.push('파트너')
  }
  return type === 'ALL' ? (
    '전체'
  ) : (
    <>
      {searchPlacements.length > 0 &&
        `검색 매체: ${searchPlacements.join(', ')}`}
      {searchPlacements.length > 0 && contentPlacements.length > 0 && <br />}
      {contentPlacements.length > 0 &&
        `콘텐츠 매체: ${contentPlacements.join(', ')}`}
    </>
  )
}
PlacementName.propTypes = {
  type: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
}
export default PlacementName
